// extracted by mini-css-extract-plugin
export default {"formHeading":"AI-z","form":"BI-z","submitBtn":"CI-z","disabled":"DI-z","input":"EI-z","error":"FI-z","submitMsg":"GI-z","signIn":"HI-z"};